export class ManagerCardOverBudget implements IManagerCardOverBudget {
    private _managerSourceId: string;
    private _displayName: string;
    private _jobTitleInternal: string;
    private _budgetCycleId: number;
    private _overSpent: number;
    private _isoCurrencyCode: string;

    constructor(managerOverBudgetDto: IManagerCardOverBudget) {
        this._managerSourceId = managerOverBudgetDto.managerSourceId;
        this._displayName = managerOverBudgetDto.displayName;
        this._jobTitleInternal = managerOverBudgetDto.jobTitleInternal;
        this._budgetCycleId = managerOverBudgetDto.budgetCycleId;
        this._overSpent = managerOverBudgetDto.overSpent;
        this._isoCurrencyCode = managerOverBudgetDto.isoCurrencyCode;
    }

    get managerSourceId(): string {
        return this._managerSourceId;
    }

    get displayName(): string {
        return this._displayName;
    }

    get jobTitleInternal(): string {
        return this._jobTitleInternal;
    }

    get overSpent(): number {
        return this._overSpent;
    }

    get isoCurrencyCode(): string {
        return this._isoCurrencyCode;
    }

    get budgetCycleId(): number {
        return this._budgetCycleId;
    }
}